import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Segment, Header, Table, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import Moment from 'moment';

import ClaimStatusLabel from '../../../component/claim/claim_status_label';
import {
    getHradminEmployeeClaimsListData
} from '../../../actions';

const typeOfClaimList = {
    1 : "Panel Visit",
    2 : "Inpatient Claim",
    3 : "Outpatient Claim"
};

class HradminEmployeeViewClaimsListPage extends Component {
    componentDidMount() {
        const {uuid} = this.props.match.params;
        const {accessToken} = this.props.user;
        const selectedEmployeeData = _.find(this.props.employeelistData, (employee) => employee.uuid === uuid);
        if (selectedEmployeeData) {
            this.props.getHradminEmployeeClaimsListData({userId: uuid, accessToken});
        }
    }
    render() {
        const {uuid} = this.props.match.params;
        return (
            <Grid columns={1}>
                <Grid.Column>
                    <Header block attached="top">
                        View Claims
                    </Header>
                    <Segment attached>
                        <Table celled selectable>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Reference Number</Table.HeaderCell>
                                    <Table.HeaderCell>Visit/Admission Date</Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                    <Table.HeaderCell>Clinic / Hospital / Provider</Table.HeaderCell>
                                    <Table.HeaderCell>Type</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                            {
                                _.map(this.props.employeeClaimsList, (claim) => {
                                    const {
                                        t, // 1-panel visit, 2-inpatient claim, 3-outpatient claim
                                        p, // provider name
                                        c, // currency (in/out only: 2/3)
                                        ia, // incurred amount
                                        s, // status (in/out only: 2/3)
                                        tx, // transaction no. (in/out only: 2/3)
                                        vn, // visit number
                                        vd, // date of visit (panel/in: 1/2)
                                        ad, // admission date (out: 3)
                                    } = claim;
                                    if (tx && (t === 2 || t === 3)) {
                                        return (
                                            <Table.Row key={tx}>
                                                <Table.Cell>
                                                    <Link to={(t === 3) ? `/hradmin/employees/${uuid}/claims/out/${tx}` : `/hradmin/employees/${uuid}/claims/inp/${tx}`}>
                                                        {vn} / {tx}
                                                    </Link>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {Moment((vd || ad), 'D/M/YYYY').format('DD MMM YYYY')}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <ClaimStatusLabel status={s} />
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {p}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {typeOfClaimList[t]}
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    }
                                })
                            }
                            </Table.Body>
                        </Table>
                    </Segment>
                </Grid.Column>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        employeelistData: state.hradmin.employeelistData,
        user: state.user.user,
        employeeClaimsList: state.hradmin.employeeClaimsList,
        selectedEmployeeToView: state.hradmin.selectedEmployeeToView,
    };
}

export default connect(mapStateToProps, {
    getHradminEmployeeClaimsListData,
})(HradminEmployeeViewClaimsListPage);
